<ul class="nav  menu mr-auto">
    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }"
        (mouseover)="hoverSansSousMenu()" (click)="hideSlide()">
        <a [routerLink]="['/']" class="text-maj">
            <div class="dashboard">
            </div>
            ACCUEIL
        </a>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()" (click)="hideSlide()"
        *ngIf="common.droitParam.parametrage && !common.droitParam.fonctionAdmin && !common.droitParam.fonctionAdminkerlog">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/param']">
            <div>
                <i class="fa fa-credit-card" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            param
        </a>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()" (click)="hideSlide()"
        *ngIf="!common.droitParam.parametrage && common.droitParam.fonctionAdmin">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/fonctionAdmin']">
            <div>
                <i class="fa fa-credit-card" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            Fonctions d'admin
        </a>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()" (click)="hideSlide()"
        *ngIf="!common.droitParam.parametrage && common.droitParam.fonctionAdminkerlog">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/fonctionAdminKerlog']">
            <div>
                <i class="fa fa-credit-card" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            Fonctions d'admin KERLOG
        </a>
    </li>

    <li class="nav-item" (mouseover)="mouseoverModule('param', $event)"
        *ngIf="common.droitParam.parametrage && (common.droitParam.fonctionAdmin ||  common.droitParam.fonctionAdminkerlog )"
        (mouseleave)="mouseoutModule('param')" [ngClass]="{'active': activeClass('param')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.param}">
            <div>
                <i class="fa fa-credit-card" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            param
        </a>

        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'param'}" *ngIf="common.clickMenu.param">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.droitParam.parametrage">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/param']">
                    <div>
                        <i class="fa fa-credit-card" aria-hidden="true"
                            style="font-size: 1.4em !important;padding-top: 2px;"></i>
                    </div>
                    param
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.droitParam.fonctionAdmin">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/fonctionAdmin']">
                    <i class="fa fa-sliders" aria-hidden="true"
                        style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    <span style="position: relative;top: 0px;">Fonctions d'admin</span>
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.droitParam.fonctionAdminkerlog">
                <a href="javascript:void(0)" class="text-maj text-center"
                    [routerLink]="['/recylog/fonctionAdminKerlog']">
                    <i class="fa fa-cogs" aria-hidden="true" style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    <span style="position: relative;top: 0px;">Fonctions d'admin KERLOG</span>
                </a>
            </li>

        </ul>
    </li>


    <li *ngIf="(common.isCompta || common.isCaisse) && !common.isPrestation"
        (mouseover)="mouseoverModule('finances', $event)" (mouseleave)="mouseoutModule('finances')"
        [ngClass]="{'active': activeClass('finances')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.finances}">
            <div class="menu-compta" *ngIf="!hoverMenu.finances">
            </div>

            <span *ngIf="!hoverMenu.finances"> FINANCES </span>
            <div class="titreModule" [ngClass]="{'active': menuSelected() === 'finances'}" *ngIf="hoverMenu.finances"
                style="width: 100%;"> FINANCES </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'finances'}"
            *ngIf="common.clickMenu.finances">
            <li [routerLinkActive]="['active']"
                *ngIf="(env.moduleEcofact || env.moduleEcopol) && common.isCompta && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/gestion_compta']">
                    <div class="menu-compta">
                    </div>
                    <span style="position: relative;top: -5px;">Compta</span>
                </a>
            </li>

            <li [routerLinkActive]="['active']" *ngIf="(env.moduleEcofact) && common.isCompta && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/ediweb']">
                    <div class="menu-compta">
                    </div>
                    <span style="position: relative;top: -5px;">Ediweb </span>
                </a>
            </li>
            <li [routerLinkActive]="['active']" *ngIf="(env.moduleEcofact || env.moduleEcopol) && common.isCompta && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecopol/genererFichierVirement']">
                    <div class="menu-compta">
                    </div>
                    <span style="position: relative;top: -5px;">Virements </span>
                </a>
            </li>

            <li [routerLinkActive]="['active']" *ngIf="env.moduleEcopol && common.isCaisse && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecopol/caisse']">
                    <div>
                        <i class="fa fa-credit-card" aria-hidden="true"
                            style="font-size: 1.4em !important;padding-top: 2px;"></i>
                    </div>
                    <span>CAISSE </span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" (mouseover)="mouseoverModule('export', $event)" (mouseleave)="mouseoutModule('export')"
        [ngClass]="{'active': activeClass('export')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.export}">
            <div>
                <i class="fa fa-bar-chart" aria-hidden="true" style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            EXPORT
        </a>

        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'export'}"
            *ngIf="common.clickMenu.export">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.isLibradata">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/libradata']">
                    <i class="fa fa-bar-chart" aria-hidden="true"
                        style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    <span style="position: relative;top: 0px;">Libradata</span>
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/export']">
                    <i class="fa fa-bar-chart" aria-hidden="true"
                        style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    <span style="position: relative;top: 0px;">Documents</span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.isImportFichiersPesees"
        (mouseover)="hoverSansSousMenu()" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/import']">
            <div>
                <i class="fa fa-download" aria-hidden="true" style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            Import
        </a>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/fiche_client_2']">
            <div>
                <i class="fa fa-address-book" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            Clients
        </a>
    </li>
    
    <li *ngIf="common.gestionFIP && common.isFIPCET" (mouseover)="mouseoverModule('fipcap', $event)"
        (mouseleave)="mouseoutModule('fipcap')" [ngClass]="{'active': activeClass('fipcap')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.fipcap}">
            <div class="ecocontrat" *ngIf="!hoverMenu.fipcap">
            </div>

            <span *ngIf="!hoverMenu.fipcap"> FIP/CAP </span>
            <div class="titreModule" [ngClass]="{'active': menuSelected() === 'fipcap'}" *ngIf="hoverMenu.fipcap"
                style="width: 100%;"> FIP/CAP </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'fipcap'}"
            *ngIf="common.clickMenu.fipcap">
            <li [routerLinkActive]="['active']" *ngIf="common.gestionFIP && common.isFIPCET">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/fip']">
                    <div class="ecocontrat">
                    </div>
                    <span style="position: relative;top: -5px;">FIP</span>
                </a>
            </li>

           <li [routerLinkActive]="['active']" *ngIf="common.gestionFIP && common.isFIPCET">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/cap']">
                    <div class="ecocontrat">
                    </div>
                    <span style="position: relative;top: -5px;">CAP</span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.isProspectHolding"
        (mouseover)="hoverSansSousMenu()" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/prospects']">
            <div>
                <i class="fa fa-address-book" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            PROSPECTS
        </a>
    </li>

    <!-- <li class="nav-item" *ngIf="common.isDetenteur && !common.isPrestation" (mouseover)="hoverSansSousMenu()" -->
    <li class="nav-item" *ngIf="common.isDetenteur && !common.isPrestation" (mouseover)="hoverSansSousMenu()"
        [routerLinkActive]="['active']" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/fiche_detenteur']">
            <div>
                <i class="fa fa-address-book" aria-hidden="true"
                    style="font-size: 1.4em !important;padding-top: 2px;"></i>
            </div>
            Détenteur
        </a>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()" (click)="hideSlide()"
        *ngIf="common.isBAK">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/bak']">
            <div>
                <i class="fa fa-map-marker" aria-hidden="true"
                    style="font-size: 1.5em !important;padding-top: 1px;"></i>
            </div>
            BAK
        </a>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()"
        *ngIf="common.isGestionDemande" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/demandes']">
            <div class="menu-bon">
            </div>
            Demandes
        </a>
    </li>
    <li *ngIf="env.moduleEcobac && common.isPlanningBac" (mouseover)="mouseoverModule('ecobac', $event)"
        (mouseleave)="mouseoutModule('ecobac')" [ngClass]="{'active': activeClass('ecobac')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecobac}">
            <div class="ecobac" *ngIf="!hoverMenu.ecobac">
            </div>

            <span *ngIf="!hoverMenu.ecobac"> ECOBAC </span>
            <div class="titreModule" [ngClass]="{'active': menuSelected() === 'ecobac'}" *ngIf="hoverMenu.ecobac"
                style="width: 100%;"> ECOBAC </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecobac'}"
            *ngIf="common.clickMenu.ecobac">
            <li [routerLinkActive]="['active']" *ngIf="common.isPlanningBac && common.isDroitPlanningEcobac">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobac/planning_bac']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">PLANNING</span>
                </a>
            </li>

            <li [routerLinkActive]="['active']" *ngIf="common.isEcobac  && common.isDroitValidationEcobac">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobac/validation']">
                    <div class="menu-bon-ul">
                    </div>
                    <span style="position: relative;top: -5px;">VALIDATION</span>
                </a>
            </li>

            <li [routerLinkActive]="['active']" *ngIf="common.isEcobac">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobac/stock_bac']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">STOCK</span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" (mouseover)="mouseoverModule('ecobennes', $event)" (mouseleave)="mouseoutModule('ecobennes')"
        *ngIf="env.moduleEcobennes && common.isEcobennes" [ngClass]="{'active': activeClass('ecobennes')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecobennes}">
            <div class="ecobennes">
            </div>
            <span>ECOBENNES</span>
        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecobennes'}"
            *ngIf="common.clickMenu.ecobennes">
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcobennes && common.isEcobennes && common.isDroitCreationMouvementEcobennes">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobennes/mvt_bennes']">
                    <div>
                        <i class="fa fa-exchange" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Contenant</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcobennes && common.isEcobennes && common.isTournee">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobennes/tournees']">
                    <div style="padding: 4px;">
                        <i class="fa fa-undo" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;transform: rotate(145deg);"></i>
                    </div>
                    <span style="position: relative;top: -5px;">tournées</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcobennes && common.isEcobennes">
                <a href="javascript:void(0)" class="text-maj text-center"
                    [routerLink]="['/ecobennes/planning_contenant']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">Planning</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcobennes && env.moduleEcocarto && common.isEcobennes && common.isEcoPAV">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobennes/cartographie']">
                    <div>
                        <i class="fa fa-map-marker" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>CARTE tournées</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcobennes && env.moduleEcocarto && common.isEcobennes && common.isCarteChauffeurs">
                <a href="javascript:void(0)" class="text-maj text-center"
                    [routerLink]="['/ecobennes/cartographie_chauffeur']">
                    <div>
                        <i class="fa fa-map-marker" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Geoloc chauffeurs</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcobennes && common.isEcobennes && common.isDroitValideRetourEcobennes">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecobennes/retour_bons']">
                    <div class="menu-bon-ul">
                    </div>
                    <span style="position: relative;top: -5px;">Retour des bons</span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" (mouseover)="mouseoverModule('ecogar', $event)" (mouseleave)="mouseoutModule('ecogar')"
        *ngIf="env.moduleEcogar && common.isEcogar" [ngClass]="{'active': activeClass('ecogar')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecogar}">
            <div class="ecogar">
            </div>
            <span>ECOGAR</span>
        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecogar'}"
            *ngIf="common.clickMenu.ecogar">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcogar">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecogar/parcentretien']">
                    <div class="ecogar">
                    </div>
                    <span style="position: relative;top: -5px;">Parc et entretien</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcogar && common.isPlanningMoyenEcogar">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecogar/planning-moyens']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">Planning des moyens</span>
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcogar">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecogar/planning']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">Planning de la maintenance</span>
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcogar">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecogar/validation']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">Validation</span>
                </a>
            </li>
        </ul>
    </li>
    <li *ngIf="env.moduleEcocrm && common.isEcocrm && !common.isPrestation"
        (mouseover)="mouseoverModule('ecogrc', $event)" (mouseleave)="mouseoutModule('ecogrc')"
        [ngClass]="{'active': activeClass('ecogrc')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecogrc}">
            <div class="ecogrc" *ngIf="!hoverMenu.ecogrc">
            </div>

            <span *ngIf="!hoverMenu.ecogrc"> ECOGRC </span>
            <div class="titreModule" [ngClass]="{'active': menuSelected() === 'ecogrc'}" *ngIf="hoverMenu.ecogrc"
                style="width: 100%;"> ECOGRC </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecogrc'}"
            *ngIf="common.clickMenu.ecogrc">
            <li class="" [routerLinkActive]="['active']" *ngIf="env.moduleEcocrm && common.isEcocrm">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocrm/planning']">
                    <div>
                        <i class="fa fa-address-book" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>rdv</span>
                </a>
            </li>
            <li class="" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcocrm && common.isEcocrm  && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocrm/gestion_devis']">
                    <div>
                        <i class="fa fa-file-text-o" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Devis</span>
                </a>
            </li>
            <li [routerLinkActive]="['active']" *ngIf="env.moduleEcocrm && common.isEcocrm  && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocrm/relance_devis']">
                    <div class="relance">
                    </div>
                    <span style="position: relative;top: -5px;">Relance</span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()"
        *ngIf="env.moduleEcocrm && common.isEcocrm && common.isPrestation" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocrm/planning']">
            <div class="ecogrc">
            </div>
            GRC
        </a>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="hoverSansSousMenu()"
        *ngIf="env.moduleEcocontrat && common.isContratFact && common.isPrestation" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocontrat/contrat']">
            <div class="ecocontrat">
            </div>
            CONTRAT
        </a>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecocontrat', $event)"
        (mouseleave)="mouseoutModule('ecocontrat')" [ngClass]="{'active': activeClass('ecocontrat')}"
        *ngIf="env.moduleEcocontrat && common.isContratFact && !common.isPrestation">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecocontrat}">
            <div class="ecocontrat">
            </div>
            <span *ngIf="!hoverMenu.ecocontrat"> ECOCONTRAT </span>
            <div class="titreModule" [ngClass]="{'active': menuSelected() === 'ecocontrat'}"
                *ngIf="hoverMenu.ecocontrat" style="width: 100%;"> ECOCONTRAT </div>
        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecocontrat'}"
            *ngIf="common.clickMenu.ecocontrat">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcocontrat && common.isContratFact && common.isApproEcocontrat">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocontrat/appro']">
                    <div>
                        <i class="fa fa-exchange" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Appro</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcocontrat && common.isContratFact && common.isExpedEcocontrat">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocontrat/expedition']">
                    <div style="padding: 4px;">
                        <i class="fa fa-undo" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;transform: rotate(145deg);"></i>
                    </div>
                    <span style="position: relative;top: -5px;">Expedition</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcocontrat && common.isContratFact && common.isFacturationEcocontrat">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecocontrat/contrat']">
                    <div class="menu-fact">
                    </div>
                    <span style="position: relative;top: -5px;">Facturation</span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" (mouseover)="mouseoverModule('ecofact', $event)" (mouseleave)="mouseoutModule('ecofact')"
        *ngIf="env.moduleEcofact && common.isEcofact && !common.isPrestation"
        [ngClass]="{'active': activeClass('ecofact')}">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecofact}">
            <div class="ecofact">
            </div>
            <span> ECOFACT</span>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecofact'}"
            *ngIf="common.clickMenu.ecofact">
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isFactBon && !common.isPrestation  &&  common.isDroitBonAFacturer">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/gestion_bons']">
                    <div class="menu-fact">
                    </div>
                    <span style="position: relative;top: -5px;">Bon à facturer</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isFactBon && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/pro_forma']">
                    <div>
                        <i class="fa fa-file-text-o" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Pro forma</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isBonachat && !common.isPrestation && common.isGestionFact">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/gestion_achat']">
                    <div>
                        <i class="fa fa-ticket" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Bon d'achat</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isFacture && !common.isPrestation && common.isGestionFact">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/gestion_facture']">
                    <div class="menu-facture">
                    </div>
                    <span style="position: relative;top: -5px;">Facture</span>
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isPaiement  && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/gestion_paie']">
                    <div>
                        <i class="fa fa-credit-card" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>Paiement</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isRelance &&  !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/relance_fact']">
                    <div class="relance">
                    </div>
                    <span style="position: relative;top: -5px;">Relance</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcofact && common.isModuleEcoachat &&  !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecofact/achats_generaux']">
                    <div class="relance">
                    </div>
                    <span style="position: relative;top: -5px;">Achats généraux</span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" (mouseover)="mouseoverModule('ecoloc', $event)" (mouseleave)="mouseoutModule('ecoloc')"
        [ngClass]="{'active': activeClass('ecoloc')}"
        *ngIf="env.moduleEcoloc && common.isEcoloc  && !common.isPrestation">
        <a href="javascript:void(0)" class="text-maj" [ngClass]="{'menuhover': hoverMenu.ecoloc}">
            <div *ngIf="!hoverMenu.ecoloc" class="ecoloc">
            </div>
            <span *ngIf="!hoverMenu.ecoloc"> ECOLOC </span>
            <div class="titreModule" [ngClass]="{'active': menuSelected() === 'ecoloc'}" *ngIf="hoverMenu.ecoloc"
                style="width: 100%;"> ECOLOC </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecoloc'}"
            *ngIf="common.clickMenu.ecoloc">
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcoloc && common.isEcoloc  && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj" [routerLink]="['ecoloc/planning']">
                    <div class="planning">
                    </div>
                    <span style="position: relative;top: -5px;">Planning</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcoloc && common.isEcoloc  && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['ecoloc/validation']">
                    <div class="menu-bon-ul">
                    </div>
                    <span style="position: relative;top: -5px;">VALIDATION</span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" (mouseover)="mouseoverModule('ecorh', $event)" (mouseleave)="mouseoutModule('ecorh')"
        [ngClass]="{'active': activeClass('ecorh')}" *ngIf="env.moduleEcorh && common.isEcorh && !common.isPrestation">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecorh}">
            <div class="ecorh" *ngIf="!hoverMenu.ecorh">
            </div>
            <span *ngIf="!hoverMenu.ecorh"> ECORH</span>
            <div class="titreModule" *ngIf="hoverMenu.ecorh" [ngClass]="{'active': menuSelected() === 'ecorh'}"
                style="width: 100%;">ECORH</div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecorh'}" *ngIf="common.clickMenu.ecorh">
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcorh && common.isEcorh && !common.isPrestation && common.isDroitGestionPersoEcoRH">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecorh/planning']">
                    <div class="menu-rh">
                    </div>
                    <span style="position: relative;top: -5px;">rh</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcorh && common.isEcorh && common.isDroitGestionHeureEcoRH">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecorh/heure']">
                    <div>
                        <span class="glyphicon glyphicon-time"
                            style="font-size: 1.3em !important;padding-top: 4px;"></span>
                    </div>
                    <span style="position: relative;top: -2px;">HEURES</span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="env.moduleEcorh && common.isEcorh && common.isExportPaie && !common.isPrestation">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecorh/paie']">
                    <div class="menu-compta">
                    </div>
                    <span style="position: relative;top: -5px;">PAIE</span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecodechet', $event)"
        [ngClass]="{'active': activeClass('ecodechet')}" (mouseleave)="mouseoutModule('ecodechet')"
        *ngIf="env.moduleEcodechet && common.isEcodechet">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecodechet}">
            <div class="ecodechet" *ngIf="!hoverMenu.ecodechet">
            </div>
            <span *ngIf="!hoverMenu.ecodechet"> ECODECHET</span>
            <div class="titreModule text-center" [ngClass]="{'active': menuSelected() === 'ecodechet'}"
                *ngIf="hoverMenu.ecodechet" style="width: 100%;">ECODECHET</div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecodechet'}"
            *ngIf="common.clickMenu.ecodechet">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodechet ">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodechet/entrees']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>entrees</span>
                </a>
            </li>

            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodechet">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodechet/sorties']">
                    <div>
                        <i class="fa fa-arrow-circle-o-up" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span>sorties</span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecopol', $event)"
        [ngClass]="{'active': activeClass('ecopol')}" (mouseleave)="mouseoutModule('ecopol')"
        *ngIf="env.moduleEcopol && common.isEcopol">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecopol}">
            <div class="ecopol" *ngIf="!hoverMenu.ecopol">
            </div>
            <span *ngIf="!hoverMenu.ecopol"> ECOPOL </span>
            <div class="titreModule text-center" [ngClass]="{'active': menuSelected() === 'ecopol'}"
                *ngIf="hoverMenu.ecopol" style="width: 100%;">ECOPOL </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecopol'}"
            *ngIf="common.clickMenu.ecopol">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcopol">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecopol/bap']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> BAP </span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecotri', $event)"
        [ngClass]="{'active': activeClass('ecotri')}" (mouseleave)="mouseoutModule('ecotri')"
        *ngIf="env.moduleEcotri && common.isEcotri">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecotri}">
            <div class="ecotri" *ngIf="!hoverMenu.ecotri">
            </div>
            <span *ngIf="!hoverMenu.ecotri"> ECOTRI </span>
            <div class="titreModule text-center" [ngClass]="{'active': menuSelected() === 'ecotri'}"
                *ngIf="hoverMenu.ecotri" style="width: 100%;">ECOTRI </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecotri'}"
            *ngIf="common.clickMenu.ecotri">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcotri && common.isTri ">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecotri/entrees']">
                    <div>
                        <i class="fa fa-recycle" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Tri des entrées </span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcotri && common.isTriSortie">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecotri/sortie']">
                    <div>
                        <i class="fa fa-recycle" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Tri des sorties </span>
                </a>
            </li>
        </ul>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecodec', $event)"
        [ngClass]="{'active': activeClass('ecodec')}" (mouseleave)="mouseoutModule('ecodec')"
        *ngIf="env.moduleEcodec && common.isEcodec">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecodec}">
            <div class="ecodec" *ngIf="!hoverMenu.ecodec">
            </div>
            <span *ngIf="!hoverMenu.ecodec"> ECODEC </span>
            <div class="titreModule text-center" [ngClass]="{'active': menuSelected() === 'ecodec'}"
                *ngIf="hoverMenu.ecodec" style="width: 100%;">ECODEC </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecodec'}"
            *ngIf="common.clickMenu.ecodec">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodec">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodec/vhu']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Gestion des VHU </span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodec">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodec/exp']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Expédition </span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecodd', $event)"
        [ngClass]="{'active': activeClass('ecodd')}" (mouseleave)="mouseoutModule('ecodd')"
        *ngIf="env.moduleEcodd && common.isEcodd">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecodd}">
            <div class="ecodd" *ngIf="!hoverMenu.ecodd">
            </div>
            <span *ngIf="!hoverMenu.ecodd"> ECODD </span>
            <div class="titreModule text-center" [ngClass]="{'active': menuSelected() === 'ecodd'}"
                *ngIf="hoverMenu.ecodd" style="width: 100%;"> ECODD </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecodd'}" *ngIf="common.clickMenu.ecodd">
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodd">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodd/entrees']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Gestion des entrées </span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodd">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodd/stock']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Gestion du stock </span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodd">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodd/expedition']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Expédition </span>
                </a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleEcodd">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecodd/bsd']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Retour BSD </span>
                </a>
            </li>
        </ul>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" (mouseover)="mouseoverModule('ecostock', $event)"
        [ngClass]="{'active': activeClass('ecostock')}" (mouseleave)="mouseoutModule('ecostock')"
        *ngIf="env.moduleEcostock && common.isEcostock">
        <a href="javascript:void(0)" class="text-maj text-center" [ngClass]="{'menuhover': hoverMenu.ecostock}">
            <div class="ecostock" *ngIf="!hoverMenu.ecostock">
            </div>
            <span *ngIf="!hoverMenu.ecostock"> ECOSTOCK </span>
            <div class="titreModule text-center" [ngClass]="{'active': menuSelected() === 'ecostock'}"
                *ngIf="hoverMenu.ecostock" style="width: 100%;">ECOSTOCK </div>

        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'ecostock'}"
            *ngIf="common.clickMenu.ecostock">
            <li class="nav-item" [routerLinkActive]="['active']"
                *ngIf="common.isEcostockFact && common.isDroitGestionEcostock">
                <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/ecostock/stock']">
                    <div>
                        <i class="fa fa-arrow-circle-o-down" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Gestion du stock </span>
                </a>
            </li>
        </ul>
    </li>


    <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.isPrestation" (mouseover)="hoverSansSousMenu()"
        (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/prestation']">
            <div class="menu-bon">
            </div>
            Prestations
        </a>
    </li>
    <li class="nav-item" [routerLinkActive]="['active']" *ngIf="common.isPrestation" (mouseover)="hoverSansSousMenu()"
        (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/adv']">
            <div class="menu-fact">
            </div>
            ADV
        </a>
    </li>

    <li class="nav-item" [routerLinkActive]="['active']" *ngIf="env.moduleRDV && common.isRDV"
        (mouseover)="hoverSansSousMenu()" (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center" [routerLink]="['/recylog/rdv']">
            <div class="planning">
            </div>
            RDV
        </a>
    </li>

    <li class="nav-item btnQuitter" *ngIf="!showBrd" (mouseover)="mouseoverModule('compte', $event)"
        (mouseleave)="mouseoutModule('compte')" [routerLinkActive]="['active']">
        <a class="text-maj text-center" >
            <!-- <div class="compteUser">
               </div> -->
            <div>
                <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 1.5em !important;"></i>
            </div>
            <span> {{user ? (user.login || '') : 'Votre Compte'}} </span>
        </a>
        <ul class="nav sousmenu" [ngClass]="{'activeSous': menuSelected() === 'compte', 'rightMenu0': getelement()}"
            *ngIf="common.clickMenu.compte">
            <li class="nav-item">
                <a href="javascript:void(0)" class="text-maj text-center"
                    (click)="common.openModalMonCompte(modalService);mouseoutModule('compte')">
                    <div>
                        <i class="fa fa-user" aria-hidden="true"
                    style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Mon compte </span>
                </a>
            </li>

            <li class="nav-item">
                <a href="javascript:void(0)" class="text-maj text-center"
                    (click)="common.openModalInfo(modalService);mouseoutModule('compte')">
                    <div>
                        <i class="fa fa-question-circle-o" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> A propos </span>
                </a>
            </li>
            <li class="nav-item">
                <a href="javascript:void(0)" class="text-maj text-center"
                    (click)="clickBtn(); mouseoutModule('compte')">
                    <div>
                        <i class="fa fa-sign-out" aria-hidden="true"
                            style="font-size: 1.3em !important;padding-top: 4px;"></i>
                    </div>
                    <span> Quitter </span>
                </a>
            </li>
        </ul>
    </li>
    <!-- <li class="nav-item" *ngIf="!showBrand()" (mouseover)="hoverSansSousMenu()" (click)="clickBtn()"
        (click)="hideSlide()">
        <a href="javascript:void(0)" class="text-maj text-center">
            <div>
                <i class="fa fa-sign-out" aria-hidden="true" style="font-size: 1.5em !important;"></i>
            </div>
            QUITTER
        </a>
    </li> -->
</ul>
